angular.module('dnecom')
    .controller('LocalLoginController', ["$scope", "$http", "$timeout", function ($scope, $http, $timeout) {
        $scope.error = null;
        $scope.team = {id: 0};
        $scope.loading = false;
        $scope.user = {};

        $scope.searchTeam = function () {
            if (!$scope.team.hasOwnProperty('name') || $scope.team.name == '') {
                return;
            }

            $scope.loading = true;

            $http.post(Routing.generate('users_team'), $scope.team)
                .then(function(response) {
                    if (!response.data.success) {
                        $scope.error = response.data.message;
                        return;
                    }

                    $timeout(function() {
                        $scope.team = response.data.team;
                        $scope.error = null;
                    });
                }, function() {
                    $scope.error = 'Request error. Please try again.';
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        };

        $scope.login = function () {
            $scope.error = null;
            $scope.loading = true;

            $scope.user.team = $scope.team.id;
            $http.post(Routing.generate('local_login_check'), $scope.user)
                .then(function(response) {
                    if (!response.data.success) {
                        $scope.error = response.data.message;
                        return;
                    }

                    document.location.href = Routing.generate('manager_dashboard');
                }, function() {
                    $scope.error = 'Request error. Please try again.';
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        }
    }]);
